import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import "./form-dialog.scss";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import Translated from "../../components/Translated/Translated";
import translator from "../../utils/translator";

function ConfirmSaveAccountPricingDialog(props) {

    const [open, setOpen] = React.useState(false);

    async function handleClickOpen() {
        if (props.markupAmount > 1 || props.markupAmount < 0) {
            props.toastFromSetProjectPricingChildComponent(true, translator("Misc", "margin_invalid"));
        } else if(props.project_allowance_amount > 999999 || props.project_allowance_amount < 0) {
            props.toastFromSetProjectPricingChildComponent(true, translator("Misc", "allowance_invalid"));
        }else {
            setOpen(true);
        }
    }

    function handleClose() {
        setOpen(false);
    }

    return (
        <div style={{ float: "right" }}>
            <Button style={{ marginBottom: "5em" }} variant="outlined" color="primary" onClick={handleClickOpen}>
                <Translated section="Misc" label="save_label" />
			</Button>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title set-price-dialog-header">
                    <Translated section="Admin Pricing" label="account_margin_dialog_title" />{" "}
                    <Button id="set-price-close-button" onClick={handleClose} color="primary">
                        <i class="fa fa-window-close fa-2x" aria-hidden="true" />
                    </Button>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <p>
                            <Translated section="Admin Pricing" label="account_margin_dialog_message_1" />
						</p>
                    </DialogContentText>
                    <div style={{ float: "right" }}>
                        <button
                            onClick={props.saveAccountPricing}
                            type="button"
                            class="btn btn-primary set-price-confirm-button"
                        >
                            <Translated section="Misc" label="yes_btn" />
                        </button>
                        <button
                            onClick={handleClose}
                            type="button"
                            class="btn btn-primary set-price-confirm-button"
                        >
                            <Translated section="Misc" label="no_btn" />
                        </button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}



const mapStateToProps = state => ({
    APIUrl: state.APIUrl

});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmSaveAccountPricingDialog);